import React from "react";
import { Button, ButtonGroup } from "reactstrap";

interface Estagio {
  id?: number;
  estagio_id?: number;
  nome: string;
}

interface Props {
  estagios: Estagio[];
  selecionados: (number | string)[];
  onChange: (selecionados: (number | string)[]) => void;
}

const EstagiosBreadcrumb: React.FC<Props> = ({ estagios, selecionados, onChange }) => {
  if (!estagios || estagios.length === 0) return null;

  function getId(estagio: Estagio): number {
    return Number(estagio.id ?? estagio.estagio_id);
  }

  function handleClick(id: number) {
    if (selecionados.includes(id)) {
      onChange(selecionados.filter((s) => s !== id));
    } else {
      onChange([...selecionados, id]);
    }
  }

  return (
    <div style={{ overflowX: "auto", width: "100%", paddingBottom: "4px" }}>
      <ButtonGroup
        className="py-2"
        style={{ fontSize: "14px", flexWrap: "nowrap", minWidth: "max-content", width: "100%" }}
      >
        {estagios.map((estagio, index) => {
          const id = getId(estagio);
          const ativo = selecionados.includes(id);
          return (
            <Button
              key={id}
              color="light"
              style={{
                flex: "0 0 auto",
                minWidth: "200px",
                fontSize: ".85rem",
                fontWeight: "normal",
                color: ativo ? "white" : "#6c757d",
                backgroundColor: ativo ? "#0847D6" : "#f8f9fa",
                position: "relative",
                clipPath:
                  index === 0
                    ? "polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%)"
                    : index === estagios.length - 1
                    ? "polygon(0 0, 100% 0, 100% 100%, 0 100%, 5% 50%)"
                    : "polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%, 5% 50%)",
                border: "none",
              }}
              onClick={() => handleClick(id)}
            >
              {estagio.nome}
            </Button>
          );
        })}
      </ButtonGroup>
    </div>
  );
};

export default EstagiosBreadcrumb;
